var Message = require('message');
var UserMixins = require('usermixins');


var User = Backbone.Model.extend($.extend(true, {}, UserMixins, {
    initialize: function (data, options) {
        options = options || {};
        this.session = options.session;
        this.connection = options.connection;
        this.buffer = options.buffer;
        this.message = options.message;
    },
    isIgnored: function (options) {
        return this.connection.isIgnored(this.getNick(), this.getHostMask(), options);
    },
    isSelf: function () {
        return this.equals(this.connection.getUser());
    },
    url: function () {
        return this.connection.buildUrl(['messages', this.getNick()]);
    },
    getCid: function () {
        return this.connection.getCid();
    },
    bid: function () {
        if (this.buffer) {
            return this.buffer.bid();
        }
    },
    getId: function () {
        return this.connection.buildId('messages', this.normalise());
    },
    
    equals: function (user) {
        return this.getCid() == user.getCid() &&
               this.getNick().toLowerCase() == user.getNick().toLowerCase();
    },
    getDisplayAuthor: function () {
        return this.get('display_name');
    },
    getRawHostmask: function () {
        return this.get('usermask');
    },
    getRawIdent: function () {
        return this.get('user');
    },
    getRawHost: function () {
        return this.get('userhost');
    },
    getAccount: function () {
        return this.get('account');
    },
    getInfo: function () {
        var info = '';
        var hostmask = this.getHostMask();
        var realname = this.getRealname();
        if (realname) {
            info += realname;
            if (hostmask) {
                info += ' (';
            }
        }
        if (hostmask) {
            info += hostmask;
            if (realname) {
                info += ')';
            }
        }
        return info;
    },
    setAway: function (msg) {
        this.set({away: msg || true});
    },
    setBack: function () {
        this.set({away: false});
    },
    getAway: function () {
        return this.get('away');
    },
    isAway: function () {
        return !!this.getAway();
    },
    getNick: function () {
        return this.get('nick');
    },
    normalise: function () {
        return this.getName().toLowerCase();
    },
    getName: function () {
        return this.getNick();
    },
    getDisplayName: function () {
        return this.getDisplayAuthor() || this.getName();
    },
    getStatusText: function () {
        return this.get('status_text');
    },
    getPronouns: function () {
        return this.get('pronouns');
    },
    getTitle: function () {
        if (this.connection && !this.connection.hasMeaningfulHostnames()) {
            return this.getNick();
        } else {
            return this.getTitleWithHostmask();
        }
    },
    getTitleWithHostmask: function () {
        var title = this.getNick();
        var hostmask = this.getHostMask();
        if (hostmask) {
            title += ' (' + hostmask + ')';
        }
        return title;
    },
    getRealname: function () {
        var realname = this.get('realname') || this.get('server_realname');
        if (this.connection && this.connection.isSlack() && realname == 'null') {
            realname = '';
        }
        return realname;
    },
    getTwitchUrl: function (withProtocol) {
        return 'https://www.twitch.tv/' + this.normalise();
    },
    getSlackUrl: function () {
        return this.connection.getSlackBaseUrl() + 'team/' + this.normalise();
    },
    isMatrix: function () {
        var realname = this.getRealname();
        if (realname) {
            // e.g. @user:example.com
            // https://matrix.org/docs/spec/intro.html#user-identifiers
            var mxid = realname.match(/^@([a-z0-9.=_-]+):([^\s]+)$/i);
            if (mxid) {
                try {
                    var u = new URL('http://' + mxid[2]);
                    if (u.host == mxid[2]) {
                        return true;
                    }
                } catch (exc) {
                    // pass
                }
            }
            return false;
        }
    },
    getTitleWithRealname: function () {
        var name = this.getNick();
        var realname = this.getRealname();
        if (realname) {
            name += ' (' + realname + ')';
        }
        return name;
    },
    openBuffer: function () {
        return this.connection.openBuffer(this.getNick());
    },
    findConversation: function () {
        return this.connection.findConversation(this.getNick());
    },
    // Actions
    say: function (message, options) {
        options = options || {};
        var conversation = this.findConversation();
        if (conversation) {
            conversation.say(message, options);
            conversation.select();
        } else {
            this.connection.setFocusOnMakeBuffer(this.getNick());
            this.connection.prefillInputHistory(this.getNick(), [message]);
            if (message && message.length > Message.LONG_MESSAGE_LIMIT) {
                this.session.currentBuffer.trigger('longMessageConfirm', _.bind(function () {
                    this._doSay(message, options);
                }, this), options.onCancel);
            } else {
                this._doSay(message, options);
            }
        }
    },
    _doSay: function (message, options) {
        options = options || {};
        this.connection.say({
            to: this.getNick(),
            msg: message
        }, options.onConfirm);
    },
    post: function (method, message, callback) {
        return this.connection.post(method, message, callback);
    },
    getBanMask: function (withIdentPrefix) {
        var irccloudUid = this.irccloudUid({
            strict: true,
            numeric: true
        });
        var hostmask;
        if (irccloudUid) {
            hostmask = '*!*id' + irccloudUid + '@*irccloud.com*';
        } else if (this.get('userhost')) {
            var user = this.get('user');
            if (user) {
                if (withIdentPrefix && this.get('ident_prefix')) {
                    user = this.get('ident_prefix') + user;
                }
            } else {
                user = '*';
            }
            hostmask = '*!' + user + '@' + this.get('userhost');
        } else if (this.get('usermask')) {
            hostmask = '*!' + this.get('usermask');
        } else {
            hostmask = this.getNick() + '!*@*';
        }
        return hostmask;
    },
    invite: function (channel) {
        // TODO make this a web service so we don't need to construct the call, and can accept channels without #
        this.connection.say({
            msg: "/invite " + this.getNick() + " " + channel
        });
    },
    whois: function () {
        var nick = this.getNick();
        var params = {
            nick: nick
        };
        this.post('whois', params);
        // This is a separate extra request because remote WHOIS calls can sometimes lag way more than local calls
        var whoisServer = this.get('ircserver');
        if (whoisServer && whoisServer != '*') {
            params.server = whoisServer;
            this.post('whois', params);
        } else if (this.channel) {
            // Use nick twice if they're in a channel
            params.server = nick;
            this.post('whois', params);
        }
    },
    
    // Mode methods
    setMode: function (mode) {
        this.set({mode: mode});
    },
    getMode: function () {
        return this.get('mode') || '';
    },
    previousMode: function () {
        return this.previous('mode') || '';
    },
    hasMode: function (mode) {
        if (!mode) {
            return false;
        }
        return this.getMode().indexOf(mode) !== -1;
    },
    hadMode: function (mode) {
        if (!mode) {
            return false;
        }
        return this.previousMode().indexOf(mode) !== -1;
    },
    isMemberType: function (mode) {
        return this.hasMode(mode);
    },
    wasMemberType: function (mode) {
        return this.hadMode(mode);
    },
    isOper: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.OPER);
    },
    isOwner: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.OWNER);
    },
    isAdmin: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.ADMIN);
    },
    isOp: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.OP);
    },
    isHalfOp: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.HALFOP);
    },
    isVoiced: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.VOICED);
    },
    isMod: function (modes) {
        return this.isHalfOp(modes) || this.canOp(modes);
    },
    isModeAbove: function (category) {
        var hierarchy = this.connection.getUserModeHierarchy();
        var c = this.getModeCategory();
        return c !== 'MEMBER' && hierarchy.indexOf(c) <= hierarchy.indexOf(category);
    },
    wasModeAbove: function (category) {
        var hierarchy = this.connection.getUserModeHierarchy();
        var c = this.getPreviousModeCategory();
        return c !== 'MEMBER' && hierarchy.indexOf(c) <= hierarchy.indexOf(category);
    },
    canOp: function () {
        return this.isModeAbove('OP');
    },
    wasOper: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.OPER);
    },
    wasOwner: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.OWNER);
    },
    wasAdmin: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.ADMIN);
    },
    wasOp: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.OP);
    },
    wasHalfOp: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.HALFOP);
    },
    wasVoiced: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.VOICED);
    },
    wasMod: function () {
        return this.wasHalfOp() || this.couldOp();
    },
    couldOp: function () {
        return this.wasModeAbove('OP');
    },
    
    getModeCategory: function (modes) {
        modes = modes || this.connection.getUserModes();
        return _.find(this.connection.getUserModeHierarchy(), function (cat) {
            return this.hasMode(modes[cat]);
        }, this) || 'MEMBER';
    },
    getPreviousModeCategory: function (modes) {
        modes = modes || this.connection.getUserModes();
        return _.find(this.connection.getUserModeHierarchy(), function (cat) {
            return this.hadMode(modes[cat]);
        }, this) || 'MEMBER';
    },
    getModeClass: function () {
        return User.defaultClassNames[this.getModeCategory()] ||
            'mode_' + this.getModeCategory();
    },
    getPreviousModeClass: function () {
        return User.defaultClassNames[this.getPreviousModeCategory()] ||
            'mode_' + this.getPreviousModeCategory();
    },
    getModeTitle: function () {
        return User.defaultTitles[this.getModeCategory()] || this.getModeCategory();
    },
    getPrefixSymbol: function () {
        var prefixes = this.connection.getISupport('PREFIX') || User.defaultPrefixes;
        var prefixLetters = this.connection.usermodes;
        var result = _.reduce(this.getMode(), function (memo, m) {
            var index = prefixLetters.indexOf(m);
            if (index !== -1 && (memo.maxIndex === -1 || index < memo.maxIndex)) {
                memo = {
                    maxIndex: index,
                    symbol: prefixes[m]
                };
            }
            return memo;
        }, {maxIndex: -1});
        return result.symbol;
    },
    getModeSymbol: function () {
        return this.getPrefixSymbol() || User.defaultSymbols[this.getModeCategory()];
    }
}), {
    defaultModeHierarchy: [
        'OPER',
        'OWNER',
        'ADMIN',
        'OP',
        'HALFOP',
        'VOICED'
    ],
    defaultModeLetters: {
        OPER: 'y',
        OWNER:  'q',
        ADMIN:  'a',
        OP:     'o',
        HALFOP: 'h',
        VOICED: 'v'
    },
    defaultSymbols: {
        OPER: '!',
        OWNER:  '~',
        ADMIN:  '&',
        OP:     '@',
        HALFOP: '%',
        VOICED: '+',
        MEMBER: '•'
    },
    defaultTitles: {
        OPER: 'Oper',
        OWNER:  'Owner',
        ADMIN:  'Admins',
        OP:     'Ops',
        HALFOP: 'Half ops',
        VOICED: 'Voiced',
        MEMBER: 'Members'
    },
    defaultClassNames: {
        OPER: 'oper',
        OWNER:  'owner',
        ADMIN:  'admin',
        OP:     'ops',
        HALFOP: 'halfops',
        VOICED: 'voiced',
        MEMBER: 'members'
    }
});
User.defaultPrefixes = {};
_.each(User.defaultModeHierarchy, function (m) {
    User.defaultPrefixes[User.defaultModeLetters[m]] = User.defaultSymbols[m];
});
User.defaultModes = {};
_.each(User.defaultModeHierarchy, function (m) {
    User.defaultModes[User.defaultModeLetters[m]] = m;
});


module.exports = User;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/user.js
// module id = Xgjh
// module chunks = 1